///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

const leftClick = 0;

const clearSelection = () => {
  if (window.getSelection) {
    if (window.getSelection().empty) {
      window.getSelection().empty();
    } else if (window.getSelection().removeAllRanges) {
      window.getSelection().removeAllRanges();
    }
  } else if (document.selection) {
    document.selection.empty();
  }
};

export const redirectToBid = (e, bidId, history) => {
  const url = `/bid/${bidId}/summary`;

  if (e.button === leftClick && e.shiftKey) {
    window.open(url, "_blank");
    clearSelection();
  } else if (e.button === leftClick && e.ctrlKey) {
    window.open(url);
  } else if (e.button === leftClick) {
    history.push(`/bid/${bidId}/summary`);
    window.scrollTo(0, 0);
  }
};

export default redirectToBid;
